export default {
  getAppVersion() {
    return process.env.VUE_APP_VERSION;
  },
  isDevelopment() {
    return process.env.NODE_ENV === 'development';
  },
  isUsingMockApi() {
    return process.env.VUE_APP_USE_MOCK_API === 'true';
  },
  isInMockApiMode() {
    return this.isDevelopment() && this.isUsingMockApi();
  },
  getApiGatewayUrl() {
    return process.env.VUE_APP_API_GATEWAY_URL;
  },
  getAuthServiceUrl() {
    return process.env.VUE_APP_AUTHENTICATION_BASE_URL;
  },
};
